import * as React from 'react';

import AdminNoticeBanner from 'admin/components/AdminNoticeBanner';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Container from 'components/Container';
import Heading from 'components/Heading';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row';
import Text from 'components/Text';
import ValuePropConstants from 'constants/ValuePropConstants';
import ValuePropsRow from 'components/ValuePropsRow';
import sisSyncPath from 'admin/lib/sisSyncPath';

type Props = {
  orgUuid: string;
  showStudentIdPercentageWarning: boolean;
  onClickNewAutoMessage: () => void;
};

export default class AdminAutoMessagesNull extends React.PureComponent<Props> {
  render() {
    const autoMessagesValueProps = [
      ValuePropConstants.AUTO_MESSAGE_TRANSFER_DATA,
      ValuePropConstants.AUTO_MESSAGE_COMPOSE_AND_REVIEW,
      ValuePropConstants.AUTO_MESSAGE_GO_LIVE,
    ];

    const { orgUuid, showStudentIdPercentageWarning, onClickNewAutoMessage } = this.props;

    return (
      <Text element="div" align="center">
        <Row size="large">
          <Row>
            <Row size="small">
              <Heading>
                <Text size="xxlarge">Auto Messages</Text>
              </Heading>
            </Row>
            <Text size="medium">
              Enhance your communication with students and parents by sending recurring messages
            </Text>
          </Row>
          <Row size="small">
            {showStudentIdPercentageWarning && (
              <Row size="small">
                <AdminNoticeBanner
                  actionElement={
                    <Button href={sisSyncPath(orgUuid)} level="secondary">
                      Sync Remind with your SIS
                    </Button>
                  }
                  glyph="caution"
                  color="sunrise">
                  <React.Fragment>
                    <Row size="xsmall">
                      <Text element="div">
                        Most of the students in your organizations don’t have student numbers on
                        Remind.
                      </Text>
                    </Row>
                    <Text element="div" color="thunder">
                      You’ll only be able to message students with student numbers on Remind. To add
                      student numbers to students, sync Remind with your SIS.{' '}
                      <Link
                        href={LinkConstants.ROSTERING_GUIDE}
                        target="_blank"
                        data-test="learn-more-button">
                        Learn more
                      </Link>
                    </Text>
                  </React.Fragment>
                </AdminNoticeBanner>
              </Row>
            )}
          </Row>
          <ValuePropsRow valueProps={autoMessagesValueProps} />
        </Row>
        {!showStudentIdPercentageWarning && (
          <Container size="xxsmall">
            <Buttons axis="y">
              <Button
                color="brand"
                onClick={onClickNewAutoMessage}
                data-test="new-auto-message-button">
                New auto message
              </Button>
              <Button
                level="text"
                color="brand"
                weight="semibold"
                href={LinkConstants.AUTO_MESSAGING_HELP}
                target="_blank"
                data-test="learn-more-button">
                Learn more
              </Button>
            </Buttons>
          </Container>
        )}
      </Text>
    );
  }
}
